<template>
<div class="chapter">
<div class="inner_page">
<div class="generated-style" id="weitgmefm">
<p class="body" xml:lang="en-us" xmlns:xml="http://www.w3.org/XML/1998/namespace"><span class="no-style-override-6">All the world’s a stage,</span></p>
<p class="body" xml:lang="en-us" xmlns:xml="http://www.w3.org/XML/1998/namespace"><span class="no-style-override-6">And all the men and women merely players;</span></p>
<p class="body" xml:lang="en-us" xmlns:xml="http://www.w3.org/XML/1998/namespace"><span class="no-style-override-6">They have their exits and their entrances,</span></p>
<p class="body" xml:lang="en-us" xmlns:xml="http://www.w3.org/XML/1998/namespace"><span class="no-style-override-6">And one man in his time plays many parts,</span></p>
<p class="body" xml:lang="en-us" xmlns:xml="http://www.w3.org/XML/1998/namespace"><span class="no-style-override-6">His acts being seven ages.</span></p>
<p class="body-override-2" xml:lang="en-us" xmlns:xml="http://www.w3.org/XML/1998/namespace"><span>—Shakespeare</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Dedication.vue?36de5cd0